import { VizState } from '@cubejs-client/react';

export const getSecEventVolumeTotal = (
  reportStart: string,
  reportEnd: string,
  clientUid: string
): VizState => {
  return {
    chartType: 'number',
    pivotConfig: {
      x: [],
      y: ['measures']
    },
    query: {
      measures: ['security_event.count'],
      order: {},
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        },
        {
          member: 'security_event.createdDate',
          operator: 'inDateRange',
          values: [reportStart, reportEnd]
        },
        {
          member: 'security_event.priority',
          operator: 'notEquals',
          values: ['P5', '5']
        }
      ]
    }
  };
};
export const getSecEventVolumeByStatusTotal = (
  reportStart: string,
  reportEnd: string,
  clientUid: string,
  status: string
): VizState => {
  return {
    chartType: 'number',
    pivotConfig: {
      x: [],
      y: ['measures']
    },
    query: {
      measures: ['security_event.count'],
      order: {},
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        },
        {
          member: 'security_event.createdDate',
          operator: 'inDateRange',
          values: [reportStart, reportEnd]
        },
        {
          member: 'security_event.status',
          operator: 'equals',
          values: [status]
        },
        {
          member: 'security_event.priority',
          operator: 'notEquals',
          values: ['P5', '5']
        }
      ]
    }
  };
};
export const getSecEventVolumeByDay = (
  reportStart: string,
  reportEnd: string,
  clientUid: string
): VizState => {
  return {
    chartType: 'number',
    query: {
      measures: ['security_event.count'],
      timeDimensions: [
        {
          dimension: 'security_event.createdDate',
          granularity: 'day'
        }
      ],
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        },
        {
          member: 'security_event.createdDate',
          operator: 'inDateRange',
          values: [reportStart, reportEnd]
        },
        {
          member: 'security_event.priority',
          operator: 'notEquals',
          values: ['P5', '5']
        }
      ]
    },
    pivotConfig: {
      x: ['security_event.createdDate.day'],
      y: ['measures'],
      fillMissingDates: true
    }
  };
};
export const getAvgTimeToStartTriage = (
  reportStart: string,
  reportEnd: string,
  clientUid: string
): VizState => {
  return {
    chartType: 'number',
    pivotConfig: {
      x: [],
      y: ['measures']
    },
    query: {
      measures: ['security_event_extended.avg_time_to_triage_minutes'],
      order: {},
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        },
        {
          member: 'security_event.createdDate',
          operator: 'inDateRange',
          values: [reportStart, reportEnd]
        },
        {
          member: 'security_event.priority',
          operator: 'notEquals',
          values: ['P5', '5']
        }
      ]
    }
  };
};

export const getAvgTimeToAction = (
  reportStart: string,
  reportEnd: string,
  clientUid: string
): VizState => {
  return {
    chartType: 'number',
    pivotConfig: {
      x: [],
      y: ['measures']
    },
    query: {
      measures: ['security_event_extended.avg_time_to_action_minutes'],
      order: {},
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        },
        {
          member: 'security_event.createdDate',
          operator: 'inDateRange',
          values: [reportStart, reportEnd]
        },
        {
          member: 'security_event.priority',
          operator: 'notEquals',
          values: ['P5', '5']
        }
      ]
    }
  };
};
